var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTicketIdIcon = function SvgTicketIdIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 13,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#E6F1F2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3.833 7.833h3M4 4.767l.8.8L6.667 3.7M.5 1.833v10.102c0 .254.272.415.494.292l1.621-.894a.67.67 0 0 1 .612-.017l1.817.877a.67.67 0 0 0 .58 0l1.816-.876a.67.67 0 0 1 .612.016l1.62.894a.333.333 0 0 0 .495-.292V1.833C10.167 1.097 9.57.5 8.833.5h-7C1.097.5.5 1.097.5 1.833"
  })));
};
export { SvgTicketIdIcon as ReactComponent };
export default __webpack_public_path__ + "a0c09ae5e04b860cec16951121d78d15.svg";